import { useMutation } from "react-query";
import { CreateAttachmentRequestParams, createAttachment } from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const createAttachmentFn = async (params: CreateAttachmentRequestParams) => {
  return await createAttachment(params);
};

export function useCreateAttachment() {
  return useMutation(createAttachmentFn, {
    mutationKey: MUTATION_KEYS.createAttachment,
    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
